import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from "@angular/core";
import {  ResearchCard} from '../../shared'

@Component({
    selector: 'app-research-cards',
    templateUrl: "./research-cards.component.html",
    styleUrls: ["./research-cards.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ResearchCardsComponent implements OnInit {
    @Input() researchCards: ResearchCard[] = [];
    @Input() showEdit: boolean = false;
    @Input() showRemove: boolean = false;

    @Output() onCardAction: any = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    editCard(card) {
        this.onCardAction.emit({ TYPE: 'EDIT', VALUE: card });
    }

    removeCard(index) {
        this.onCardAction.emit({ TYPE: 'DELETE', VALUE: index });
    }
}
